'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Div = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  /* DISPLAY */\n  display: ', ';\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  /* POSITION */\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n'], ['\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  /* DISPLAY */\n  display: ', ';\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  /* POSITION */\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    margin: ', ';\n  '], ['\n    margin: ', ';\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    padding: ', ';\n  '], ['\n    padding: ', ';\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    text-align: ', ';\n  '], ['\n    text-align: ', ';\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n    width: ', ';\n  '], ['\n    width: ', ';\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n    height: ', ';\n  '], ['\n    height: ', ';\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['\n    background-color: ', ';\n  '], ['\n    background-color: ', ';\n  ']),
    _templateObject8 = _taggedTemplateLiteral(['\n    background-image: ', ';\n  '], ['\n    background-image: ', ';\n  ']),
    _templateObject9 = _taggedTemplateLiteral(['\n    border: ', ';\n  '], ['\n    border: ', ';\n  ']),
    _templateObject10 = _taggedTemplateLiteral(['\n    box-shadow: ', ';\n  '], ['\n    box-shadow: ', ';\n  ']),
    _templateObject11 = _taggedTemplateLiteral(['\n    border-radius: ', ';\n  '], ['\n    border-radius: ', ';\n  ']),
    _templateObject12 = _taggedTemplateLiteral(['\n    cursor: ', ';\n  '], ['\n    cursor: ', ';\n  ']),
    _templateObject13 = _taggedTemplateLiteral(['\n    justify-content: ', ';\n  '], ['\n    justify-content: ', ';\n  ']),
    _templateObject14 = _taggedTemplateLiteral(['\n    align-items: ', ';\n  '], ['\n    align-items: ', ';\n  ']),
    _templateObject15 = _taggedTemplateLiteral(['\n    flex-direction: ', ';\n  '], ['\n    flex-direction: ', ';\n  ']),
    _templateObject16 = _taggedTemplateLiteral(['\n    flex-basis: ', ';\n  '], ['\n    flex-basis: ', ';\n  ']),
    _templateObject17 = _taggedTemplateLiteral(['\n    flex-grow: ', ';\n  '], ['\n    flex-grow: ', ';\n  ']),
    _templateObject18 = _taggedTemplateLiteral(['\n    position: ', ';\n  '], ['\n    position: ', ';\n  ']),
    _templateObject19 = _taggedTemplateLiteral(['\n    top: ', ';\n  '], ['\n    top: ', ';\n  ']),
    _templateObject20 = _taggedTemplateLiteral(['\n    left: ', ';\n  '], ['\n    left: ', ';\n  ']),
    _templateObject21 = _taggedTemplateLiteral(['\n    right: ', ';\n  '], ['\n    right: ', ';\n  ']),
    _templateObject22 = _taggedTemplateLiteral(['\n    bottom: ', ';\n  '], ['\n    bottom: ', ';\n  ']),
    _templateObject23 = _taggedTemplateLiteral(['\n    z-index: ', ';\n  '], ['\n    z-index: ', ';\n  ']),
    _templateObject24 = _taggedTemplateLiteral(['\n    ', ';\n  '], ['\n    ', ';\n  ']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Div = exports.Div = _styledComponents2.default.div(_templateObject, function (props) {
  return props.margin && (0, _styledComponents.css)(_templateObject2, props.margin);
}, function (props) {
  return props.padding && (0, _styledComponents.css)(_templateObject3, props.padding);
}, function (props) {
  return props.textAlign && (0, _styledComponents.css)(_templateObject4, props.textAlign);
}, function (props) {
  return props.width && (0, _styledComponents.css)(_templateObject5, props.width);
}, function (props) {
  return props.height && (0, _styledComponents.css)(_templateObject6, props.height);
}, function (props) {
  return props.bgColor && (0, _styledComponents.css)(_templateObject7, props.bgColor);
}, function (props) {
  return props.bgImg && (0, _styledComponents.css)(_templateObject8, props.bgImg);
}, function (props) {
  return props.border && (0, _styledComponents.css)(_templateObject9, props.border);
}, function (props) {
  return props.boxShadow && (0, _styledComponents.css)(_templateObject10, props.boxShadow);
}, function (props) {
  return props.borderRadius && (0, _styledComponents.css)(_templateObject11, props.borderRadius);
}, function (props) {
  return props.cursor && (0, _styledComponents.css)(_templateObject12, props.cursor);
}, function (props) {
  return props.display ? props.display : 'block';
}, function (props) {
  return props.justifyContent && (0, _styledComponents.css)(_templateObject13, props.justifyContent);
}, function (props) {
  return props.alignItems && (0, _styledComponents.css)(_templateObject14, props.alignItems);
}, function (props) {
  return props.flexDirection && (0, _styledComponents.css)(_templateObject15, props.flexDirection);
}, function (props) {
  return props.flexBasis && (0, _styledComponents.css)(_templateObject16, props.flexBasis);
}, function (props) {
  return props.flexGrow && (0, _styledComponents.css)(_templateObject17, props.flexGrow);
}, function (props) {
  return props.position && (0, _styledComponents.css)(_templateObject18, props.position);
}, function (props) {
  return props.top && (0, _styledComponents.css)(_templateObject19, props.top);
}, function (props) {
  return props.left && (0, _styledComponents.css)(_templateObject20, props.left);
}, function (props) {
  return props.right && (0, _styledComponents.css)(_templateObject21, props.right);
}, function (props) {
  return props.bottom && (0, _styledComponents.css)(_templateObject22, props.bottom);
}, function (props) {
  return props.zIndex && (0, _styledComponents.css)(_templateObject23, props.zIndex);
}, function (props) {
  return props.moreStyle && (0, _styledComponents.css)(_templateObject24, props.moreStyle);
});

exports.default = Div;


//////////////////
// WEBPACK FOOTER
// ./node_modules/konsys-ui/dist/lib/div/index.js
// module id = 332
// module chunks = 0